import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import './Sponsors.css';

import { API_BASE_URL, IMG_BASE } from "../apiConfig";

const Sponsors = () => {
    const [sponsors, setSponsors] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSponsors = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${API_BASE_URL}/api/sponsors`);
                const data = await response.json();
                setSponsors(data);
            } catch (error) {
                console.error("Error fetching sponsors:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchSponsors();
    }, []);

    const mainLogos = sponsors.length > 0 ? sponsors.map(s => s.LogoFile.startsWith('http') ? s.LogoFile : IMG_BASE + s.LogoFile) : [];

    const supportedLogos = [
        "https://mks.org.au/wp-content/uploads/2025/03/sup-1.png",
        "https://mks.org.au/wp-content/uploads/2025/03/sup-2.png",
        "https://mks.org.au/wp-content/uploads/2025/03/sup-3.png",
        "https://mks.org.au/wp-content/uploads/2025/03/sup-4.png",
        "https://mks.org.au/wp-content/uploads/2025/03/sup-5.png",
        "https://mks.org.au/wp-content/uploads/2025/03/sup-6.png",
        "https://mks.org.au/wp-content/uploads/2025/03/sup-7.png",
        "https://mks.org.au/wp-content/uploads/2025/03/sup-8.png"
    ];




    const sponsorVideos = [
        "https://mks.org.au/wp-content/uploads/2024/04/Kannada-Copy-of-India-Video-1.mp4",
        "https://mks.org.au/wp-content/uploads/2024/04/Total-Environment-1.mp4"
    ];


    return (
        <div className="sponsors-page">
            {/* Hero Section */}
            <section className="sponsors-hero">
                <div className="sponsors-hero-overlay"></div>
                <img src="/Comittee.jpg" alt="Sponsors Hero" className="sponsors-hero-bg" />
                <div className="sponsors-hero-content">
                    <h1 className="sponsors-hero-title fade-up">Sponsors</h1>
                </div>
            </section>

            {/* Promotional Videos Section */}
            <section className="sponsors-video-section sponsors-swiper-section no-title">
                <div className="sponsors-video-grid">
                    {sponsorVideos.map((video, index) => (
                        <div key={index} className="sponsor-video-card">
                            <video
                                src={video}
                                controls
                                playsInline
                                preload="metadata"
                                className="sponsor-video-player"
                            >
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    ))}
                </div>
            </section>

            {/* Main Content Area */}
            <div className="sponsors-marquee-section">
                <section className="logo-marquee-wrapper sponsors-swiper-section">
                    {/* Title */}
                    <div className="supported-title-container">
                        <h2 className="supported-title">SPONSORS</h2>
                        <div className="supported-title-line"></div>
                    </div>

                    <div className="sponsors-swiper-container">
                        <Swiper
                            key={mainLogos.length}
                            modules={[Autoplay]}
                            slidesPerView={1}
                            spaceBetween={20}
                            centeredSlides={true}
                            loop={mainLogos.length > 3}
                            speed={3000}
                            autoplay={{ 
                                delay: 0, 
                                disableOnInteraction: false, 
                                pauseOnMouseEnter: false 
                            }}
                            observer={true}
                            observeParents={true}
                            breakpoints={{
                                768: { slidesPerView: 5, spaceBetween: 30 }
                            }}
                            className="marquee-swiper"
                        >
                            {loading ? (
                                <p>Loading sponsors...</p>
                            ) : (
                                mainLogos.map((logo, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="swiper-logo-card">
                                            <img src={logo} alt={`sponsor-logo-${index}`} />
                                        </div>
                                    </SwiperSlide>
                                ))
                            )}
                        </Swiper>
                    </div>
                </section>



                {/* Supported By Section */}
                <section className="supported-section sponsors-swiper-section">
                    {/* Title */}
                    <div className="supported-title-container">
                        <h2 className="supported-title">SUPPORTED BY</h2>
                        <div className="supported-title-line"></div>
                    </div>

                    <div className="sponsors-swiper-container">
                        <Swiper
                            key={supportedLogos.length}
                            modules={[Autoplay]}
                            slidesPerView={1}
                            spaceBetween={20}
                            centeredSlides={true}
                            loop={true}
                            speed={3000}
                            autoplay={{ 
                                delay: 0, 
                                disableOnInteraction: false, 
                                pauseOnMouseEnter: false 
                            }}
                            observer={true}
                            observeParents={true}
                            breakpoints={{
                                768: { slidesPerView: 5, spaceBetween: 30 }
                            }}
                            className="marquee-swiper"
                        >
                            {supportedLogos.map((logo, index) => (
                                <SwiperSlide key={index}>
                                    <div className="swiper-logo-card">
                                        <img src={logo} alt={`supported-logo-${index}`} />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </section>
            </div>

        </div>
    );
};

export default Sponsors;